/**
 * @generated SignedSource<<d203cf58142953ad6a29e747cecf2c8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSchemaRenderContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteQuoteContent" | "hooksInlinePlusWidgetContent" | "imageContent" | "inlineWidgetContent" | "photoGalleryWidgetContent" | "scmpYoutubeContent">;
  readonly " $fragmentType": "contentSchemaRenderContent";
};
export type contentSchemaRenderContent$key = {
  readonly " $data"?: contentSchemaRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSchemaRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksInlinePlusWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "imageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inlineWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "photoGalleryWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "scmpYoutubeContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "59374af8b4c2f2358f8918005a144bf7";

export default node;
